<script>
import { onDestroy } from 'svelte';
import { linear, quintOut } from 'svelte/easing';
import { liveChannel } from '../store';
import IconClap from './Icons/IconClap.svelte';
import IconCheers from './Icons/IconCheers.svelte';
import IconHeart from './Icons/IconHeart.svelte';

export let sessionId;
export let eventId;

const reactionMapping = {
  'c': IconClap,
  'r': IconCheers,
  'h': IconHeart,
}

let unsub;
let reactions = []
let index = 0;
let ignoreSet = {}

onDestroy(() => {
  unsub?.();
})

function rebind(_) {
  unsub?.();
  unsub = liveChannel.subscribe(`react-${eventId}-${sessionId}`, undefined, key => {
    // Ignore unknown reactions
    if (!reactionMapping[key]) return;

    if (ignoreSet[key] > 0) {
      ignoreSet[key]--;
      return;
    }
    add(key)
  });
}

export function add(key, ignoreNext) {
  if (ignoreNext) {
    if (!ignoreSet[key]) {
      ignoreSet[key] = 0
    }
    ignoreSet[key]++;
  }

  if (reactions.length > 50) return;
  reactions = [...reactions, {reaction: reactionMapping[key], index: index++}]
}

function bubble(node, { distance = -200, f = 8, amp = 10, duration = 1300 }) {
	const start = Math.random()
  return {
    duration,
    css: t => {
      const eased = linear(t);
      const opacity = quintOut(1 - t);

      return `
        transform: translate(${Math.sin(eased * f + start * Math.PI) * amp}px, ${eased * distance}px) scale(${Math.sin(t * Math.PI) * .4 + 1});
        opacity: ${opacity};
      `
    }
  };
}

$: rebind(sessionId)
</script>

{#each reactions as {reaction, index}(index)}
  <div class="bubble" in:bubble on:introend={() => reactions = reactions.filter(r => r.index !== index)}>
    <svelte:component this={reaction} />
  </div>
{/each}

<style>
.bubble {
  position: absolute;
  font-size: 24px;
}
</style>